export const SetFile = [
	{
		selector: '[data-tut="DropFile"]',
		content:
			"Drag and drop a data file (.csv, .txt) and You can specify missing data values by leaving the cells blank or by entering an asterisk ( * ), NA or NaN",
		stepInteraction: false
	},
	{
		selector: '[data-tut="SetFileName"]',
		content: "The name of the data file",
		stepInteraction: false
	},
	{
		selector: '[data-tut="SetName0"]',
		content: "The name of variables in the data file",
		stepInteraction: false
	},
	{
		selector: '[data-tut="DropdownType0"]',
		content: "Click the dropdown to change the type of each variable",
		stepInteraction: false
	},
	{
		selector: '[data-tut="Duplicate0"]',
		content: "Click to duplicate the variable",
		stepInteraction: false
	},
	{
		selector: '[data-tut="Preview"]',
		content:
			"Data preview, The data preview lets you see some of the rows and columns in the data file",
		stepInteraction: false
	},
	{
		selector: '[data-tut="DeleteDownload"]',
		content: "Delete and Download the data file",
		stepInteraction: false
	}
]
